    import axios from 'axios';
import { SIGNIN_URL } from './helpers';

    const axiosInstance = axios.create({
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Request Interceptor
    axiosInstance.interceptors.request.use(
      (config) => {
        const csrfToken = document.head.querySelector('meta[name="csrf-token"]')?.getAttribute("content");
        if (csrfToken) {
          config.headers['X-CSRF-Token'] = csrfToken;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    // Response Interceptor
    axiosInstance.interceptors.response.use(
      (response) => {
        // Handle successful responses
        return response;
      },
      (error) => {
        // Handle errors, e.g., refresh token on 401, redirect to login
        const requestUrl = error?.config?.url || "";
        const isSignInRequest = requestUrl.includes("/sign_in");

        if (error?.response && error.response.status === 401 && !isSignInRequest) {
          location.href = SIGNIN_URL;
        }
        return Promise.reject(error);
      }
    );

    export default axiosInstance;
